import * as React from 'react'
import { Route } from 'react-router-dom'
import TripsHistoryColumnsMenu from '../../containers/trips/TripsHistoryColumnMenu'
import TripsHistoryDetailsModal from '../../containers/trips/TripsHistoryDetailsModal'
import TripsHistoryHeader from '../../containers/trips/TripsHistoryHeader'
import TripsHistoryList from '../../containers/trips/TripsHistoryList'
import Export from '../icons/ui/Export'
import ExportModal from './ExportModal'

export interface ITripsHistoryPane {
  exportModalOpen: boolean
}

class TripsHistoryPane extends React.Component<any, ITripsHistoryPane> {
  constructor(props: any) {
    super(props)

    this.state = {
      exportModalOpen: false
    }
  }

  public render() {
    return (
      <div className='pt3'>
        {this.exportModal()}
        <Route path={`${this.props.match.path}/:tripId`} component={TripsHistoryDetailsModal} />

        <div className='flex justify-between mb2'>
          <div className='pl3 h3'>Trips</div>
          <div className='pr3 flex align-center'>
            <span>
              <TripsHistoryColumnsMenu />
            </span>
            <span>
              <Export onClick={this.openExportModal} height={20} width={20} className='ml2 svg-grey' />
            </span>
          </div>
        </div>
        <hr />
        <div className='pr3 pl3'>
          <TripsHistoryHeader />
          <hr />
          <TripsHistoryList />
          {/* <Paginator /> */}
        </div>
      </div>
    )
  }

  private exportModal = () => {
    if (!this.state.exportModalOpen) {
      return
    }
    return <ExportModal filter='sdfsdfdfs' onClose={this.closeExportModal} />
  }

  private closeExportModal = () => {
    this.setState({ exportModalOpen: false })
  }

  private openExportModal = () => {
    this.setState({ exportModalOpen: true })
  }
}

export default TripsHistoryPane



// WEBPACK FOOTER //
// ./src/components/trips/TripsHistoryPane.tsx